"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateInvestor = exports.submitMandatoryQuestionnaire = exports.getMandatoryQuestionnaire = exports.postMarketingPreferences = exports.postNPS = exports.onboardInvestor = exports.reaccreditateInvestor = exports.getAccreditationQuestionnaire = exports.getInvestor = void 0;
const getInvestor = (serverURL, appAxios) => async () => await appAxios.get(`${serverURL}/investor`, {
  withCredentials: true
});
exports.getInvestor = getInvestor;
const getAccreditationQuestionnaire = (serverURL, appAxios) => async () => await appAxios.get(`${serverURL}/investor/accreditation/questionnaire`, {
  withCredentials: true
});
exports.getAccreditationQuestionnaire = getAccreditationQuestionnaire;
const reaccreditateInvestor = (serverURL, appAxios) => async data => await appAxios.post(`${serverURL}/investor/reaccreditation`, data, {
  withCredentials: true
});
exports.reaccreditateInvestor = reaccreditateInvestor;
const onboardInvestor = (serverURL, appAxios) => async data => await appAxios.post(`${serverURL}/investor/onboarding/v2`, data, {
  withCredentials: true
});
exports.onboardInvestor = onboardInvestor;
const postNPS = (serverURL, appAxios) => async npsData => await appAxios.post(`${serverURL}/investor/nps`, npsData, {
  withCredentials: true
});
exports.postNPS = postNPS;
const postMarketingPreferences = (serverURL, appAxios) => async data => await appAxios.post(`${serverURL}/investor/marketing-preferences`, data, {
  withCredentials: true
});
exports.postMarketingPreferences = postMarketingPreferences;
const getMandatoryQuestionnaire = (serverURL, appAxios) => async () => await appAxios.get(`${serverURL}/investor/mandatory-questionnaire`, {
  withCredentials: true
});
exports.getMandatoryQuestionnaire = getMandatoryQuestionnaire;
const submitMandatoryQuestionnaire = (serverURL, appAxios) => async data => await appAxios.post(`${serverURL}/investor/mandatory-questionnaire-result`, data, {
  withCredentials: true
});
exports.submitMandatoryQuestionnaire = submitMandatoryQuestionnaire;
const updateInvestor = (serverURL, appAxios) => async data => await appAxios.put(`${serverURL}/investor`, data, {
  withCredentials: true
});
exports.updateInvestor = updateInvestor;